import { ACCOUNT_TABS } from '@/constants/account';

export const getUrl = (link, baseUrlPath) => {
  if (link.name === ACCOUNT_TABS.DISCONNECT) {
    return '#';
  }

  return `${link.isLink ? '' : baseUrlPath}/${link.name}`;
};
